// Erinnerungen zur Uhrzeit (Agent 4A, Runde 4, T-07, AU-18): Banner im App-Rahmen und Desktop-Mitteilung für Follow-ups
// mit Uhrzeit, Anrufaufgaben, verpasste Anrufe, Voicemails und SMS (components/ErinnerungBanner.tsx). Dazu der unsichtbare
// Wächter, der einen Rückruf aus der Inbox erledigt, sobald es klingelt (components/inbox/rueckruf.tsx). Der Push aufs
// Handy kommt vom Server (`api/crm_api/services/aufgaben_erinnerung.py`), auch wenn kein Browser offen ist.
import { ErinnerungBanner } from "./ErinnerungBanner";
import { RueckrufWaechter } from "./inbox/rueckruf";

export function ErinnerungenHost() {
  return (
    <>
      <ErinnerungBanner />
      <RueckrufWaechter />
    </>
  );
}
